import { IFilterRates, IFilterState, IParams } from '@root-gipro/modules/filter/models/interfaces/filter-state.model'
import { IRefreshList } from '@root-gipro/modules/filter/store/actions'
import { Action } from 'redux'

export enum FilterActions {
	SET_CALLBACKS = 'FILTER/SET_CALLBACKS',
	APPLIED_FILTERS = 'APPLIED_FILTERS',
	COPY_PROJECTS_2_CALC = 'COPY_PROJECTS_2_CALC',
	SHOW_BTN_COPY_PROJECTS_2_CALC = 'FILTER/SHOW_BTN_COPY_PROJECTS_2_CALC',
	REFRESH_FILTER_STATE = 'REFRESH_FILTER_STATE',
	SHOW_FILTER_RESULT = 'FILTER/SHOW_FILTER_RESULT',
	SET_FILTER_SORT_PARAMS = 'FILTER/SET_FILTER_SORT_PARAMS',
	SET_FILTER_RESULT_COUNT = 'FILTER/SET_FILTER_RESULT_COUNT',
	RESET_FILTER_STATE = 'FILTER/RESET_FILTER_STATE',
	SET_INIT_FILTER_STATE = 'FILTER/SET_INIT_FILTER_STATE',
	SET_FILTER_STATE = 'FILTER/SET_FILTER_STATE',
	REPLACE_FILTER_PARAMS = 'FILTER/REPLACE_FILTER_PARAMS',

	FILTER_SET_RESULT = 'FILTER_SET_RESULT',
	REFRESH_FILTER_COMMON_PROJECT_STATE = 'FILTER/REFRESH_FILTER_COMMON_PROJECT_STATE',
	FILTER_REQUEST = 'FILTER_REQUEST',

	SET_FILTER_COMMON_PROJECTS_RATES = 'SET_FILTER_COMMON_PROJECTS_RATES',
	RESET_FILTER_COMMON_PROJECTS_RATES = 'RESET_FILTER_COMMON_PROJECTS_RATES',
	SET_IS_PROJECTS_COUNT_READY = 'SET_IS_PROJECTS_COUNT_READY',
}

interface SetCallbacks {
	type: FilterActions.SET_CALLBACKS
	getInitList: () => void
	showFilterResult: (params: IParams) => void
	refreshList: (projects: IRefreshList[]) => Action
	toggleLoadingList: (loading: boolean) => Action
}

interface FiltersRequest {
	type: FilterActions.FILTER_REQUEST
	url: string
}

interface AppliedFilters {
	type: FilterActions.APPLIED_FILTERS
	params: any
}
interface FiltersShowBtnCopyProjects2Calc {
	type: FilterActions.SHOW_BTN_COPY_PROJECTS_2_CALC
	showBtnCopyProjects2Calc: boolean
}

interface FilterSetResult {
	type: FilterActions.FILTER_SET_RESULT
}

interface SetFilterSortParams {
	type: FilterActions.SET_FILTER_SORT_PARAMS
	params: any
	url: string
}

interface RefreshFilterState {
	type: FilterActions.REFRESH_FILTER_STATE
	fieldName: string
	value: string
	url: string
	convertValue: (fieldName: string, value: string) => { fieldName: string; value: string }
}
interface ShowFilterResult {
	type: FilterActions.SHOW_FILTER_RESULT
	url: string
}

interface ResetFilterState {
	type: FilterActions.RESET_FILTER_STATE
	url: string
}

interface SetInitFilterState {
	type: FilterActions.SET_INIT_FILTER_STATE
	state: any
}

interface SetFilterState {
	type: FilterActions.SET_FILTER_STATE
	state: IFilterState
}

interface SetFilterResultCount {
	type: FilterActions.SET_FILTER_RESULT_COUNT
	count: number
	url: string
}

interface SetFilterCommonProjectsRates {
	type: FilterActions.SET_FILTER_COMMON_PROJECTS_RATES
	data: IFilterRates
}

interface ResetFilterCommonProjectsRates {
	type: FilterActions.RESET_FILTER_COMMON_PROJECTS_RATES
}

interface SetIsProjectsCountReady {
	type: FilterActions.SET_IS_PROJECTS_COUNT_READY
	ready: boolean
}


export type FilterTypes =
	| ShowFilterResult
	| RefreshFilterState
	| SetFilterSortParams
	| SetCallbacks
	| FiltersRequest
	| FilterSetResult
	| ResetFilterState
	| SetInitFilterState
	| SetFilterState
	| SetFilterResultCount
	| SetFilterCommonProjectsRates
	| ResetFilterCommonProjectsRates
	| FiltersShowBtnCopyProjects2Calc
	| AppliedFilters
	| SetIsProjectsCountReady
